import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddOpportunityService } from '@app/features/customers/add-opportunity/service/add-opportunity.service';
import {FolderService} from "@app/shared/common-folder-structure/service/folder.service";

declare var $: any;
declare var tinymce: any;

@Component({
	selector: 'app-sms-modal',
	templateUrl: './sms-modal.component.html',
	styleUrls: ['../communication-modal.scss']
})
export class SmsModalComponent implements OnInit {

	smsForm: FormGroup;
	smsTemplateList: any;
	smsTemplateSearchList: any = {};
	customerSmsDetails: any;
	templateList: any;
	saveDisabled: boolean = false;
	templateData: any = {};
    smsInputTextLength: number = 0;

	@Input() showSmsModal: boolean = false;
    @Input() scheduled: boolean = true;
    @Input() scheduleActivity: boolean = true;
	@Input() customerId: number;
    @Input() invoiceId: number;
    @Input() loadFirstTemplate: boolean = false;
    @Input() replaceTagParams: any = {};

	@Output() onSave: EventEmitter<any> = new EventEmitter();
	@Output() onClose: EventEmitter<any> = new EventEmitter();
    smsScreenLabel: string = 'sms.templates';
    @Input() screenType: string;
    @Input() tablePKID:any;

	constructor(
        private fb: FormBuilder,
		private opportunityService: AddOpportunityService,
		@Inject('confirmationBoxHelper') private confirmationBoxHelper,
        @Inject('$scope') private ajsScope,
        private folderService: FolderService,
    ) {
        this.smsForm = this.fb.group({
            "contactTelephoneId": ["", Validators.required],
            "activityType": [""],
            "message": ["", Validators.required],
            "customerId": [""]
        })
	}

	ngOnInit() {
		this.getSmsTemplates();
        this.getContacts();
	}

	ngOnChanges(changes) {
		if (changes.showSmsModal) {
            if (this.showSmsModal) {
                this.smsInputTextLength = 0;
                if (this.loadFirstTemplate && this.smsTemplateSearchList.length && this.smsForm) {
                    this.templateData = this.smsTemplateSearchList[0];
                }
                // time delay to initialise tinymce and listen for keyup
                setTimeout(() => {
                    this.updateTinyMCEValues();
                }, 400);
            } else {
                this.clearForm();
            }
        }
	}

	getSmsTemplates() {
        this.opportunityService.listSmsTemplates(this.customerId, null, this.invoiceId).subscribe(
            data => {
                this.smsTemplateList = data;
                this.smsTemplateSearchList = data;
            }
        )
	}

	getContacts() {
        if (this.invoiceId) {
            this.opportunityService.getCustomerSmsAddress(this.customerId, 'Y').subscribe(
                data => {
                    if (Object.values(data).length) {
                        this.customerSmsDetails = data;
                    }
                }
            )
		} else {
            this.opportunityService.getSmsContacts(this.customerId).subscribe(
                (data: any) => {
                    let contactData: object = data['contacts'];
                    this.smsTemplateList = this.smsTemplateSearchList = data['smsTemplate'];
                    if (Object.values(contactData).length) {
                        this.customerSmsDetails = Object.values(contactData);
                    }
                }
            );
		}
	}

	searchSmsTemplates(event) {
		let templateValues = []
		this.smsTemplateSearchList.filter(value => {
			if (value["templateName"].toLowerCase().includes(event.target.value.toLowerCase())) {
				templateValues.push(value)
				this.smsTemplateList = templateValues
			}
		})
	}

	isScheduledActivity(event) {
		this.scheduled = event.target.checked
	}

	showTemplateOptions() {
		$("#smsTemplateId").val('');
		this.smsTemplateList = this.smsTemplateSearchList;
		$(".sms-template-wrapper").addClass("sms-template-open");
	}

	closeModal() {
		this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the sms?', this.ajsScope)
		.then(() => {
            this.closeModalWithoutConfirmation();
		}).catch(() => { });
	}

    clearForm(){
        this.smsForm.patchValue({
            message: '',
            contactTelephoneId: '',
        });
        tinymce.remove('#sms-template-message');
    }

	closeModalWithoutConfirmation(){
        this.clearForm();
        this.showSmsModal = false;
        this.onClose.emit();
	}

    selectedsmsTemplate(smsData: any) {
        this.replaceTagParams.message = smsData.message;
        if(this.screenType == 'jobInvoice'){
            this.replaceTagParams.screenType ='invoice';
            this.replaceTagParams.tablePKId = this.invoiceId;
            this.replaceTagParams.smsUrlType = 'short';
        }else if(this.screenType == 'jobs'){
            this.replaceTagParams.screenType ='jobs';
            this.replaceTagParams.tablePKId = this.tablePKID;
            this.replaceTagParams.smsUrlType = 'short';
        }
        this.folderService.getReplacedMessage(this.replaceTagParams).subscribe((data: any) => {
            if (data) {
                this.templateData = data;
                this.updateTinyMCEValues();
                $(".sms-template-wrapper").removeClass("sms-template-open");
            }
        });
    }

	updateTinyMCEValues() {
        tinymce.init({
            selector: "#sms-template-message",
            menubar: false,
            toolbar: false,
            plugins: "paste",
            paste_as_text: true,
            browser_spellcheck: true,
            paste_block_drop: false,
            content_css: window.location.origin + '/css/public/stylesheets/mce-editor.css',
            setup: editor => {
                editor.on('LoadContent', () => {
                    if (this.templateData.hasOwnProperty('message')) {
                        editor.setContent(this.templateData.message);
                        this.onEditorChange();
                    }
                });
                editor.on('keyup', () => {
                    this.onEditorChange();
                });
            }
        });
    }

    onEditorChange(){
        const editor = tinymce.get('sms-template-message'); // Get the editor instance
        let txtMessage = editor.getContent({ format: "text" });
        this.smsInputTextLength = txtMessage.length;
        this.smsForm.patchValue({
            message: txtMessage,
        });
        this.smsForm.updateValueAndValidity();
    }

    sendSms() {
        if (this.smsForm.valid) {
            this.saveDisabled = true;
            this.smsForm.controls['activityType'].setValue("SMS");
            this.smsForm.controls['customerId'].setValue(this.customerId);
            let smsData = this.smsForm.value;
            smsData.isScheduled = this.scheduled;
            this.onSave.emit(smsData);
            this.saveDisabled = false;
        }
	}

	cancelTemplate() {
		$(".sms-template-wrapper").removeClass("sms-template-open");
	}

}
